import { AxiosResponse } from 'axios';
import {
	AutomatedNotificationRuleSearchResponse,
	AutomatedNotificationRuleRequest,
	NotificationRuleSearchRequest,
	AutomatedNotificationRuleResponse,
} from '../../Model/Dto/AutomatedNotification/AutomatedNotificationRule';
import { axiosCoreInstance } from '../AxiosCoreInterceptor';

import * as ApiUrls from './ApiUrl.AutomatedNotification';

export const AutomatedNotificationService = {
	SearchNotificationRules: (data: NotificationRuleSearchRequest): Promise<AxiosResponse<AutomatedNotificationRuleSearchResponse>> =>
		axiosCoreInstance.post(ApiUrls.SearchAutomatedNotificationRules, data),
	
	DeleteAutomatedNotificationRule: (id: number): Promise<AxiosResponse<void>> =>
		axiosCoreInstance.delete(`${ApiUrls.DeleteAutomatedNotificationRules}/${id}`),

	GetById: (id: number): Promise<AxiosResponse<AutomatedNotificationRuleResponse>> =>
		axiosCoreInstance.get(`${ApiUrls.GetById}/${id}`),

	CreateNewAutomatedNotificationRule: (data: AutomatedNotificationRuleRequest): Promise<AxiosResponse<AutomatedNotificationRuleResponse>> =>
			axiosCoreInstance.post(ApiUrls.CreateAutomatedNotificationRule, data),

	UpdateNewAutomatedNotificationRule: (data: AutomatedNotificationRuleRequest): Promise<AxiosResponse<AutomatedNotificationRuleResponse>> =>
			axiosCoreInstance.put(ApiUrls.UpdateAutomatedNotificationRule, data),
};
